import { ApiContext } from "../ApiContext";

export class ApiBanks extends ApiContext {}
